import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {ActionBox} from 'shells/action-box/action-box';
import {ErrorIcon, SuccessIcon} from 'shells/action-box/action-icons';
import {Link} from 'shells/link/link';

import type {SmsDripSequenceFragment_from as Channel} from 'nutshell-graphql-types';

type Props = {
    from: Channel | null | undefined;
    canAccessSetup: boolean;
};

export function SmsFromActionBox(props: Props) {
    const subtitle =
        props.from && props.from.phone && props.from.phone.numberFormatted
            ? props.from.phone.numberFormatted
            : 'SMS has not been configured';
    const icon = props.from ? <SuccessIcon /> : <ErrorIcon />;
    const actionElement =
        !props.from && props.canAccessSetup ? (
            // @ts-expect-error
            <Link as={RoutedLink} variant='primary' to='/marketing/sms-setup'>
                Go to SMS settings
            </Link>
        ) : null;

    return <ActionBox title='From' subtitle={subtitle} icon={icon} actionElement={actionElement} />;
}
